export const localeIRNumberFormatter = (price: number) => new Intl.NumberFormat('ir-IR').format(price);
